import React, { ChangeEvent, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import ControlFeedback from "./../../../components/Fields/ControlFeedback";
import { ControlProps } from "./../../../components/Fields/Types";
import image_1x1 from "./../../../assets/img/layouts/1x1_image.jpg"
import SalesPresentation_popup_SelectBackgroundGraphic from "../Popups/SalesPresentation_popup_SelectBackgroundGraphic";
import ItemSearchResult from "../../../models/ItemSearchResult";

interface BackgroundGraphicControl extends ControlProps {
    label: string
    salesPresentationBackgroundProductCategoryId: number
}

const BackgroundGraphicControl: React.FC<BackgroundGraphicControl> = ({ name, value, disabled, width, validationResults, onChange, onBlur, label, salesPresentationBackgroundProductCategoryId }) => {
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [item, setItem] = useState<ItemSearchResult>();
    const [image, setImage] = useState(image_1x1)

    function onControlChange(e: ChangeEvent<HTMLInputElement>) {
        if (e.target.checked) {
            if (item) {
                setImage(item.imageUrl)
                onChange(item.itemId)
            }
        } else {
            setImage(image_1x1)
            onChange(undefined)
        }
    }

    useEffect(() => {
        if (item) {
            setImage(item.imageUrl)
            onChange(item.itemId)
        }
    }, [item])

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    return (
        <div style={{ marginTop: 10, marginRight: 10, display: 'inline-block' }} className='pull-left'>
            <img src={image} height={60} width={90} style={{ marginBottom: 5 }} onClick={() => setShowPopup(true)} />
            <div>
                <Form.Control type='checkbox' name={name} disabled={disabled} onChange={onControlChange} isInvalid={!isValid} onBlur={onBlur} style={{ height: 20, width: 20, margin: 5, marginTop:0 }} className="pull-left" />
                {label}
            </div>
            <SalesPresentation_popup_SelectBackgroundGraphic show={showPopup} onHide={(itemSearchResult?: ItemSearchResult) => { setShowPopup(false); setItem(itemSearchResult); }} productCategoryId={salesPresentationBackgroundProductCategoryId} backgroundType={label} />
        </div>
    );
}
export default BackgroundGraphicControl;